import { Entity, type EntityProps } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

export interface ProtectionGoalProps extends EntityProps {
    capabilities?: string;
}

export class ProtectionGoal extends Entity {
    capabilities?: string;

    constructor({ id, name, capabilities }: ProtectionGoalProps) {
        super({ id, name });
        this.capabilities = capabilities;
    }

    static new({
        name,
        capabilities,
    }: Omit<ProtectionGoalProps, 'id'>): ProtectionGoal {
        return new ProtectionGoal({
            id: new UUID().toString(),
            name,
            capabilities,
        });
    }
}
